import React from 'react';
import PropTypes from 'prop-types';

import styles from './ZoomableImage.css';

const IPropTypes = {
  className: PropTypes.string,
  component: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.func,
  ]),
  onBlur: PropTypes.func,
  onMouseMove: PropTypes.func,
  onMouseOut: PropTypes.func,
};

const defaultProps = {
  className: '',
  component: null,
  onBlur: () => {},
  onMouseMove: () => {},
  onMouseOut: () => {},
};

const ZOOM_SCALE_FACTOR = 1.5;
class ZoomableImage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      mouseOver: false,
      transformOrigin: null,
    };
    this._disableZoom = this._disableZoom.bind(this);
    this._enableZoom = this._enableZoom.bind(this);
    this._onBlur = this._onBlur.bind(this);
    this._onMouseMove = this._onMouseMove.bind(this);
    this._onMouseOut = this._onMouseOut.bind(this);
  }

  _enableZoom(event) {
    const { pageX, pageY } = event;
    const imageElem = event.currentTarget;
    const { offsetLeft, offsetTop } = imageElem;
    const imageWidth = imageElem.width;
    const imageHeight = imageElem.height;
    const xOffset = ((pageX - offsetLeft) / imageWidth) * 100;
    const yOffset = ((pageY - offsetTop) / imageHeight) * 100;
    const transformOrigin = `${xOffset}% ${yOffset}%`;
    this.setState({
      mouseOver: true,
      transformOrigin,
    });
  }

  _disableZoom() {
    this.setState({
      mouseOver: false,
      transformOrigin: null,
    });
  }

  _onMouseOut(event) {
    this._disableZoom();
    this.props.onMouseOut(event);
  }

  _onBlur(event) {
    this._disableZoom();
    this.props.onBlur(event);
  }

  _onMouseMove(event) {
    this._enableZoom(event);
    this.props.onMouseMove(event);
  }

  render() {
    const scaleFactor = this.state.mouseOver ? ZOOM_SCALE_FACTOR : 1;
    const style = {
      transform: `scale(${scaleFactor})`,
    };
    if (this.state.mouseOver) {
      style.transformOrigin = this.state.transformOrigin;
    }
    const propsToPass = {
      alt: '',
      ...this.props,
      className: [styles.container, this.props.className].join(' '),
      style,
      onBlur: this._onBlur,
      onMouseMove: this._onMouseMove,
      onMouseOut: this._onMouseOut,
    };
    delete propsToPass.component;
    if (this.props.component !== null) {
      return (
        <this.props.component {...propsToPass} />
      );
    }
    return (
      <img alt="" {...propsToPass} />
    );
  }
}

ZoomableImage.propTypes = IPropTypes;
ZoomableImage.defaultProps = defaultProps;

export { ZoomableImage };



// WEBPACK FOOTER //
// ./src/common/zoomable-image/ZoomableImage.jsx